import TranslationData from '@/models/TranslationData';

const translation: TranslationData = {
  search: {
    title: 'Hae',
  },
  searchResults: {
    showMore: 'Näytä enemmän tuloksia',
    noResults: 'Valitettavasti emme löytäneet yhtään tulosta hakusanallesi <b>{storeSearchTerm}</b>',
    noResultsHint: '',
    badges: {
      pfsc: '',
      fsc: '',
      fsc_pfsc: 'FSC™/PEFC™',
      ecofriendly: 'Eco',
      overnight: 'Overnight',
      sameday: 'Sameday',
      express: 'Express',
      onlineDesign: 'Online-suunnittelu',
    },
    taglines: {
      home: 'Lisätietoja',
      text: 'Lisätietoja',
      themes: 'Lisätietoja',
      external: 'Lisätietoja',
      info: 'Lisätietoja',
      category: 'Lisätietoja',
      content: 'Lisätietoja',
      product: 'Määritä tuotteesi',
    },
    headings: {
      categories: 'Tuoteryhmät',
      products: 'Tuotteet',
      external: 'Lisätietoja',
    },
    slider: {
      previousSlide: 'Näytä edellinen sisältö',
      nextSlide: 'Näytä seuraava sisältö',
    },
  },
  searchInput: {
    inputTooShortError: 'Hakutermi on liian lyhyt (min 2)',
    results: 'Tulosta',
    result: 'Tulos',
    youSearchFor: 'Näytetään tulokset haulla',
    suggestedTerm: {
      didYouMean: 'Tarkoititko',
      resultsFor: 'Hae kyselyllä',
      didYouMeanPostFix: '?',
      resultsForPostFix: '-tulokset',
    },
  },
  toolsBar: {
    buttons: {
      listButtonTooltip: 'Listanäkymä',
      gridButtonTooltip: 'Laattojen näkymä',
    },
    quickFilter: {
      filterChips: {
        clearAllFilters: 'Tyhjennä kaikki suodattimet',
        resetFilters: '',
      },
      buttonsPanel: {
        filterLabel: 'Suodattimet',
        buttonsTooltipLabel: 'Näytä',
        resultLabel: 'Hakutulokset',
      },
      contexts:
        {
          product: 'Tuotteet',
          content: 'Sekalaiset',
          all: 'all',
          category: 'Tuoteryhmät',
          external: 'Lisätietoja',
        },
    },
    breadcrumbs: {
      start: 'Alkaa',
      search: 'Hae',
    },
  },
  sideBar: {
    filter: 'Suodattaa',
    filterOverwrite: {
      category: {
        text: 'Kategoriat',
      },
      rootCategory: {
        text: 'Kategoriat',
      },
      specialFeatures: {
        text: 'Special Features',
        options: {
          logoFsc: 'FSC',
          logoPfsc: 'PFSC',
          logoFscPfsc: '',
          samedayAvailable: 'Same Day',
          expressAvailable: 'Express',
          overnightAvailable: 'Overnight',
          ecoFriendly: 'Eco Friendly',
          onlineDesign: 'Online design',
          new: 'New',
        },
      },
    },
    more: 'Show more',
    less: 'Show less',
  },
  common: {
    warnings: {
      server401: 'Istuntosi on päättynyt ja sinun on kirjauduttava uudelleen. Sinut ohjataan kirjautumiseen välittömästi.',
      server403: 'Pyyntöä ei ole sovellettu, koska siinä ei ole voimassa olevia tunnistautumistietoja. Lataa sivu uudelleen tai ota yhteyttä asiakaspalveluumme.',
      default: 'Palvelimessa tapahtui virhe. Lataa sivu uudelleen tai ota yhteyttä asiakaspalveluumme.',
    },
    errors: {
      server400: 'Pyyntö oli virheellinen. Lataa sivu uudelleen tai ota yhteyttä asiakaspalveluumme.',
      server404: '404 Sivua ei löytynyt. Siirry edelliselle sivulle tai ota yhteyttä asiakaspalveluumme.',
      server500: 'Palvelimessa tapahtui virhe. Lataa sivu uudelleen tai ota yhteyttä asiakaspalveluumme.',
      server501: 'Palvelimella tapahtui virhe. Lataa sivu uudelleen tai ota yhteyttä asiakaspalveluumme.',
      server502: 'Palvelimessa tapahtui virhe ja saat virheellisen vastauksen. Lataa sivu uudelleen tai ota yhteyttä asiakaspalveluumme.',
      server503: 'Palvelimella tapahtui virhe. Lataa sivu uudelleen tai ota yhteyttä asiakaspalveluumme.',
      server504: 'Palvelimella tapahtui virhe. Lataa sivu uudelleen tai ota yhteyttä asiakaspalveluumme.',
      default: 'Palvelimella on ongelma pyynnön kanssa. Lataa sivu uudelleen tai ota yhteyttä asiakaspalveluumme.',
    },
  },
};
export default translation;
